import * as get from 'lodash/get';

export const getVersions = state => get( state, 'versions', {} );
export const getVersionsList = state => get( getVersions( state ), 'list', [] );

export const getVersionLists = state => get( getVersions( state ), 'lists', [] );
